/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Architect_Detail9Inputs */

const en_svc_ecommerce_amazon_tools_architect_detail9 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API access, sync rules and alert thresholds.`)
};

const ar_svc_ecommerce_amazon_tools_architect_detail9 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الوصول للواجهات وقواعد المزامنة وعتبات التنبيه.`)
};

const bn_svc_ecommerce_amazon_tools_architect_detail9 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API অ্যাক্সেস, সিঙ্ক নিয়ম আর সতর্কতা সীমা।`)
};

const de_svc_ecommerce_amazon_tools_architect_detail9 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Zugang, Synchronisationsregeln und Warnschwellen.`)
};

const es_svc_ecommerce_amazon_tools_architect_detail9 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso a API, reglas de sincronización y umbrales de alerta.`)
};

const fr_svc_ecommerce_amazon_tools_architect_detail9 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès API, règles de synchronisation et seuils d'alerte.`)
};

const pt_svc_ecommerce_amazon_tools_architect_detail9 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesso à API, regras de sincronização e limites de alerta.`)
};

const zh_svc_ecommerce_amazon_tools_architect_detail9 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 接入、同步规则和告警阈值。`)
};

const tr_svc_ecommerce_amazon_tools_architect_detail9 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API erişimi, senkron kuralları ve uyarı eşikleri.`)
};

const ru_svc_ecommerce_amazon_tools_architect_detail9 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступ к API, правила синхронизации и пороги алертов.`)
};

const pl_svc_ecommerce_amazon_tools_architect_detail9 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostęp do API, reguły synchronizacji i progi alertów.`)
};

/**
* | output |
* | --- |
* | "API access, sync rules and alert thresholds." |
*
* @param {Svc_Ecommerce_Amazon_Tools_Architect_Detail9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_architect_detail9 = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Architect_Detail9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Architect_Detail9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_architect_detail9(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_architect_detail9(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_architect_detail9(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_architect_detail9(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_architect_detail9(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_architect_detail9(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_architect_detail9(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_architect_detail9(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_architect_detail9(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_architect_detail9(inputs)
	return en_svc_ecommerce_amazon_tools_architect_detail9(inputs)
});
export { svc_ecommerce_amazon_tools_architect_detail9 as "svc_ecommerce-amazon-tools_ARCHITECT_detail" }